// extracted by mini-css-extract-plugin
export default {"bold":"commom_bold__7XyPu"};